<script setup>

    import { onBeforeMount, onUpdated } from 'vue';
    //import bootstrap from "bootstrap/dist/js/bootstrap";
    import CustomersRow from '../components/CustomersRow.vue';
    import { useStore } from 'vuex';
    import { computed } from 'vue';
    import validSession from '../assets/js/valid-session';
    import axios from 'axios';
    import startResize from '../assets/js/resize';
    import SkeletonLoad from '../components/SkeletonLoad.vue';

    const store = useStore();
    const darkMode = computed(() => store.state.darkMode);

    onBeforeMount(() => {

        validSession.isLogged();

        store.state.loadingCustomers = true;
        store.state.customers = [];

        store.state.customer = {
            id: 0,
            name: '',
            document: '',
            email: '',
            phone: '',
            social_reason: '',
            municipal_registration: '',
            cep: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: ''
        }

        get_customers();

    });

    const openCustomer = (customer) => {

        store.state.customer = customer

        store.state.customer = {
            id: customer.id,
            name: customer.name,
            document: customer.document == null ? '' : customer.document,
            email: customer.email,
            phone: customer.phone,
            social_reason: customer.social_reason,
            municipal_registration: customer.municipal_registration,
            cep: customer.cep,
            street: customer.street,
            number: customer.number,
            complement: customer.complement,
            neighborhood: customer.neighborhood,
            city: customer.city,
            state: customer.state
        }

    }

    const clearFields = () => {

        store.state.customer = {
            id: 0,
            name: '',
            document: '',
            email: '',
            phone: '',
            social_reason: '',
            municipal_registration: '',
            cep: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: ''
        };

    }

    /*const openModal = (id) => {

        let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

        modal.show();

    }

    const closeModal = (id) => {

        let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById(id));

        modal.hide();

    }*/

    onUpdated(() => {
        if(!store.state.loadingCustomers){
            startResize(91);
        }
    });

    const get_customers = () => {

        axios.get('customers-suppliers?type=C')
        .then(res => {
            
            if(res.status == 200){

                store.state.customers = res.data;
                store.state.loadingCustomers = false;

            }
            
        })
        .catch(err => {
            console.error(err); 
        })
        
    };

    const getCep = async () => {

        if(store.state.customer.cep.length == 8){

            axios.get('/helpers/cep/'+store.state.customer.cep.replace('-', ''))
            .then(res => {

            if(res.status == '200'){

                store.state.customer.street = res.data.logradouro;
                store.state.customer.neighborhood = res.data.bairro;
                store.state.customer.city = res.data.localidade;
                store.state.customer.state = res.data.uf;

                document.getElementById('customerNumber').focus();

            }
            
            })
            .catch(err => {
            console.error(err); 
            })

        }  

    }

</script>
<template>
    <div class="container-fluid">
        <div class="row default-shadow">
            <div class="col-12">
                <div class="row align-items-center sticky-top header-transaction pt-3 pb-2 pb-lg-3" :class="darkMode ? 'darkmode' : ''">
                    <div class="col-6 mt-n2 mt-xl-0">
                        <h6 class="mt-xl-2 mb-n1 mb-lg-1">{{store.state.customers.length}} Clientes</h6>
                    </div>
                    <div class="col-6 text-end">
                        <a 
                            class="me-3 trasation-list-add-button mt-xl-2 mb-2 text-white"
                            type="button" 
                            id="dropdownMenuButton1"
                            data-bs-toggle="modal" 
                            data-bs-target="#addCustomer"
                                >
                                <i class="fal fa-plus-circle"></i> <span class="d-none d-lg-inline-flex">Acidionar</span>
                        </a>
                        
                    </div>
                </div>

                <div id="transactionList" class="row overflow-auto footer-customer" :class="!darkMode ? 'bg-white' : 'bg-222222'">

                    <div class="col-12 text-center mt-4 mb-4" v-if="store.state.loadingCustomers">
                        <div class="row align-items-center">

                            <div class="col-9 col-sm-10">
                                <SkeletonLoad
                                    :width="'200px'"
                                    :height="'30px'"
                                />
                            </div>
                            <div class="col-3 col-sm-2 text-end">
                                
                            </div>

                        </div>
                        
                    </div>

                    <div class="col-12 text-center mt-4" v-if="store.state.customers.length == 0 && !store.state.loadingCustomers">
                        <p>Nenhum cliente cadastrado.</p>
                    </div>

                    <div class="col-12 trasaction-list" v-if="!store.state.loadingCustomers">

                        <CustomersRow 
                            v-for="(customer, index) in store.state.customers" :key="index"
                            :customer="customer"
                            :darkmode="darkMode"
                            @edit = "openCustomer"
                        />

                    </div>

                </div>

            </div>
        </div>
    </div>

    <div class="modal fade" id="addCustomer" tabindex="-1" aria-labelledby="addCustomer" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content border-4 border-secondary" >
                <div class="modal-body rounded" :class="darkMode ? 'darkmode' : ''">
                    <div class="row">
                        <div class="col-10">
                            <b>
                                {{ store.state.customer.id != '' ? 'Editar' : 'Novo' }} cliente
                            </b>
                        </div>
                        <div class="col-2 text-end">
                            <a type="button" data-bs-dismiss="modal" @click="clearFields()">
                                <i class="fal fa-times-circle fa-lg"></i>
                            </a>
                        </div>
                        <div class="col-12 col-lg-11 mx-auto mt-3 mb-3">

                            <div class="row">

                                <div class="col-12 mb-3">
                                    <label for="customerName">Nome</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerName"
                                        name="customerName"
                                        v-model="store.state.customer.name"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerEmail">E-mail</label>
                                    <input 
                                        type="email" 
                                        class="form-control form-control-lg" 
                                        id="customerEmail"
                                        name="customerEmail"
                                        v-model="store.state.customer.email"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerTelefone">Telefone</label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="customerTelefone"
                                        name="customerTelefone"
                                        v-model="store.state.customer.phone"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                        v-mask="'(##) #####-####'"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerDocument">CPF/CNPJ</label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="customerDocument"
                                        name="customerDocument"
                                        v-model="store.state.customer.document"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                        v-mask="['###.###.###-##', '##.###.###/####-##']"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerSocialReason">Razão Social</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerSocialReason"
                                        name="customerSocialReason"
                                        v-model="store.state.customer.social_reason"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerCEP">CEP</label>
                                    <input 
                                        type="tel" 
                                        class="form-control form-control-lg" 
                                        id="customerCEP"
                                        name="customerCEP"
                                        v-model="store.state.customer.cep"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                        v-mask="'#####-###'"
                                        maxlength="9" 
                                        @keyup="getCep()" 
                                        @change="getCep()" 
                                        placeholder="00000-000"
                                    >
                                </div>

                                <div class="col-12 col-lg-8 mb-3">
                                    <label for="customerStreet">Logradouro</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerStreet"
                                        name="customerStreet"
                                        v-model="store.state.customer.street"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-4 mb-3">
                                    <label for="customerNumber">Numero</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerNumber"
                                        name="customerNumber"
                                        v-model="store.state.customer.number"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerComplement">Complemento</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerComplement"
                                        name="customerComplement"
                                        v-model="store.state.customer.complement"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerNeighborhood">Bairro</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerNeighborhood"
                                        name="customerNeighborhood"
                                        v-model="store.state.customer.neighborhood"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerCity">Cidade</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerCity"
                                        name="customerCity"
                                        v-model="store.state.customer.city"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 col-lg-6 mb-3">
                                    <label for="customerState">Estado</label>
                                    <input 
                                        type="text" 
                                        class="form-control form-control-lg" 
                                        id="customerState"
                                        name="customerState"
                                        v-model="store.state.customer.state"
                                        v-bind:class="{
                                            'darkmode': darkMode,
                                        }"
                                    >
                                </div>

                                <div class="col-12 text-center mt-4 mb-n4">
                                    <button
                                        v-if="!store.state.savingTransaction"
                                        @click="submitTransaction()"
                                        class="btn btn-secondary"
                                    >
                                        Salvar
                                    </button>
                                    <img v-if="store.state.savingTransaction" :src="loadGif" alt="" width="50">
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>